import {ChangeDetectionStrategy, Component, input, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UmpireComponentFaq} from '@tisa-group/models';
import {SvgIconComponent} from '@tisa-group/client-ui/components/svg-icon';

@Component({
  selector: 'tisa-faq',
  imports: [CommonModule, SvgIconComponent],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqComponent {
  readonly component = input<UmpireComponentFaq | undefined>();

  expandedQuestions = signal<Record<string, boolean>>({});

  ngOnInit() {
    const questions = this.component()?.faq_questions;

    if (questions) {
      this.expandedQuestions.set(
        Object.fromEntries(questions.map(question => [question.id, false])),
      );
    }
  }

  toggleQuestion(index: string) {
    this.expandedQuestions.update(prev => ({...prev, [index]: !prev[index]}));
  }
}
